import { useTranslation } from 'react-i18next';

import { ArrayFields, AttachedDocumentsTabFields } from '../../../../License/types/fieldEnums';
import { type ListItemState } from '../../../../../components/ListWithContentLayout/types';
import Card from '../../../../../components/ListWithContentLayout/components/Card/Card';
import { type IAttachedDocumentResponse } from '../../../../License/types/response';

import useComparisonValues from '../../../hooks/useComparisonValues';

import { formatDate } from '../../../../../helpers/dateHelpers';

interface IAttachedDocumentComparisonCardProps extends IAttachedDocumentResponse {
  onClick: () => void;
  searchText: string;
  isActive: boolean;
  state?: ListItemState;
  index: number;
}

function AttachedDocumentComparisonCard({
  searchText,
  onClick,
  isActive,
  state,
  id,
  index,
  ...rest
}: IAttachedDocumentComparisonCardProps) {
  const { t } = useTranslation();

  const { newValue: code } = useComparisonValues({
    path: `/${ArrayFields.attachedDocuments}/${id}/${AttachedDocumentsTabFields.code}`,
    value: rest.code,
  });

  const { newValue: name } = useComparisonValues({
    path: `/${ArrayFields.attachedDocuments}/${id}/${AttachedDocumentsTabFields.name}`,
    value: rest.name,
  });

  const { newValue: referenceNumber } = useComparisonValues({
    path: `/${ArrayFields.attachedDocuments}/${id}/${AttachedDocumentsTabFields.referenceNumber}`,
    value: rest.referenceNumber,
  });

  const { newValue: attachmentDate } = useComparisonValues({
    path: `/${ArrayFields.attachedDocuments}/${id}/${AttachedDocumentsTabFields.attachmentDate}`,
    value: rest.attachmentDate as string,
  });

  if (
    !searchText ||
    (code as string)?.startsWith(searchText) ||
    (name as string)?.toLowerCase().includes(searchText) ||
    (referenceNumber as string)?.toLowerCase().includes(searchText)
  ) {
    return (
      <Card
        title={`${index + 1}. ${(name as string) || ''}`}
        statusText={(code as string) ?? ''}
        isActive={isActive}
        onClick={onClick}
        itemState={state}
        key={id}
      >
        <div>
          <span>{t('Document Ref. No')}:</span>{' '}
          <span className="typography-dark">{(referenceNumber as string) || '-'}</span>
        </div>
        <div>
          <span>{t('Date')}:</span>{' '}
          <span className="typography-dark">{formatDate(attachmentDate as string) || '-'}</span>
        </div>
      </Card>
    );
  }

  return null;
}

export default AttachedDocumentComparisonCard;
